import {
  BeListApiGetList,
  beListGetUserColumns,
  beListPutSenderInfo,
  beListUpdateUserColumns
} from 'Api/BeListApi'
import {
  beMessGetDynamicContentByIdMessages,
  beMessGetMessageDetails
} from 'Api/BeMessApi'
import { bePecPlusGetPecPlusConfig } from 'Api/bePecPlusApi'
import {
  BEQUEUE_CONFIG_ACTION_MAIL,
  BEQUEUE_CONFIG_EXCLUDE,
  BEQUEUE_CONFIG_FILTER_COND_AND,
  BEQUEUE_CONFIG_FILTER_COND_OR,
  BEQUEUE_CONFIG_INCLUDE,
  BEQUEUE_CONFIG_TYPE_EVERYBODY,
  beQueueDeleteConfigurationById,
  beQueueExecuteConfigurationProcessing,
  beQueueGetConfigurationById,
  beQueueGetLastConfigurationsByInvio,
  beQueueGetRetryConfiguration,
  beQueueResetSendingQueue,
  beQueueSaveQueueingConfiguration,
  beQueueSimulateConfigurationProcessing,
  beQueueUpdateSenderInEmailQueue
} from 'Api/beQueueApi'
import {
  beSendGoApiGetBestPlanningDataAvailable,
  beSendGoApiGetSmartPlanningSuggestedDate,
  beSendGoCheckCreateSending,
  beSendGoCreateInactiveSchedule,
  beSendGoGetEmailSendingDetails,
  beSendGoGetNoDisturbConfig,
  beSendGoRemoveNoDisturbConfig,
  beSendGoSendingsLimits,
  beSendGoSetNoDisturbConfig,
  beSendGoSetStandBySendingToReady,
  beSendGoUpdateNoDisturbConfig
} from 'Api/beSendGoApi'

import {
  beFiltersGetFilter,
  beFiltersGetListOfCategories,
  beFiltersGetListOfFilters,
  FILTER_TYPE_ENGAGEMENT
} from 'Api/beFiltersApi'
import {
  beRecipientGetDynamicFieldsDefinition,
  beRecipientGetGroupDetails,
  beRecipientGetListOfGroupDetails,
  beRecipientGetTestsDefault,
  beRecipientLazySearch,
  beRecipientSearchForRecipients,
  CHANNEL_TYPE_EMAIL,
  GROUPS_SEARCH_TYPE_ECONTAINS,
  HAS_RECIPIENTS,
  SUBSCRIPTION_TYPE_SUBSCRIBED
} from 'Api/beRecipientApi'
import { LOGIN_TYPE_ADM, LOGIN_TYPE_ADMLIMITED } from 'Constants'
import {
  MATCH_FILTER_CONDITION_ALL,
  SENDING_SOURCE_IMMEDIATE,
  SENDING_SOURCE_SCHEDULED,
  SENDING_SOURCE_SCHEDULED_NOW
} from 'Constants/'
import evalCondition from 'Helpers/evalCondition'
import getIntl from 'Helpers/intl'
import { useStorage } from 'Hooks/'
import {
  STORE_KEY_ID_LIST,
  STORE_KEY_LIST,
  STORE_KEY_LOGIN_TYPE,
  storeGet
} from 'mailup-react-helpers'

import { PARAM_ORDER_DESC } from 'mailup-web-components'
import { RECIPIENTS_TEST_GROUP } from 'Pages/EmailSendingWizard/const'

import { beAccountsApiGetAccountStatus } from 'Api/beAccountsApi'
import { beAccountSettingsNotifyQueueing } from 'Api/beAccountSettingsApi'
import { beStatApiEvaluateSendingBestPlanningTime } from 'Api/BeStatApi'

export const evaluateSendingBestPlanningTime = async data => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beStatApiEvaluateSendingBestPlanningTime(idList, data)
  return result
}

export const getBestPlanningDataAvailable = async () => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beSendGoApiGetBestPlanningDataAvailable(idList)
  return result
}

export const getSmartPlanningSuggestedDate = async idSending => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beSendGoApiGetSmartPlanningSuggestedDate(idList, idSending)
  return result
}

export const updateSenderInEmailQueue = async (
  idSending,
  newName,
  newEmail,
  oldName,
  oldEmail
) => {
  const data = {
    OldSender: {
      Name: oldName,
      Email: oldEmail
    },
    NewSender: {
      Name: newName,
      Email: newEmail
    }
  }
  await beQueueUpdateSenderInEmailQueue(idSending, data)
}

export async function setNoDisturbConfig(idSending, value) {
  const result = beSendGoSetNoDisturbConfig(idSending, value)
  return result
}

export async function updateNoDisturbConfig(idSending, value) {
  const result = beSendGoUpdateNoDisturbConfig(idSending, value)
  return result
}

export async function removeNoDisturbConfig(idSending) {
  const result = beSendGoRemoveNoDisturbConfig(idSending)
  return result
}

export async function getNoDisturbConfig(idSending) {
  const result = beSendGoGetNoDisturbConfig(idSending)

  return result
}

export async function getMessageDetails(idMessage) {
  const result = beMessGetMessageDetails(idMessage)
  return result
}

export async function getAccountSendingLimits() {
  const result = beSendGoSendingsLimits()
  return result
}

export async function resetSendingQueue(idSending) {
  const result = beQueueResetSendingQueue(idSending)
  return result
}

export async function getLastConfigurationsByInvio(idSending) {
  const result = beQueueGetLastConfigurationsByInvio(idSending)
  return result
}

export async function fetchSenderInfo(idMessage) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const [pecConfig, lastSending, listConfig] = await Promise.all([
    bePecPlusGetPecPlusConfig(idList),
    beSendGoCheckCreateSending(idMessage),
    BeListApiGetList(idList)
  ])

  const asyncQueueConfig =
    lastSending && lastSending.Id
      ? await beQueueGetLastConfigurationsByInvio(lastSending.Id)
      : {}

  const isPEC = !!pecConfig

  const senderFromLastSending = lastSending && !!lastSending.Id

  const listReplyTo = listConfig.SenderReplyTo
    ? listConfig.SenderReplyTo
    : listConfig.BouncedEmail

  return {
    isPEC,
    pecPlusStatus: pecConfig ? pecConfig.Status : undefined,
    queueStatus: asyncQueueConfig ? asyncQueueConfig.State : undefined,
    idAsyncQueueConfig: asyncQueueConfig ? asyncQueueConfig.Id : undefined,
    queued: lastSending && lastSending.Queued ? lastSending.Queued : undefined,
    senderName: senderFromLastSending
      ? lastSending.SenderName
      : listConfig.SenderName,
    senderEmail: isPEC
      ? listConfig.SenderEmail
      : senderFromLastSending
      ? lastSending.SenderEmail
      : listConfig.SenderEmail,
    replyToEmail: isPEC
      ? listReplyTo
      : senderFromLastSending
      ? lastSending.ReplyToEmail
      : listReplyTo,
    customSender: senderFromLastSending ? lastSending.CustomSender : false,
    idFieldSenderNameMail: senderFromLastSending
      ? lastSending.idFieldSenderNameMail
      : undefined,
    idSenderEmailField: senderFromLastSending
      ? lastSending.IdSenderEmailField
      : undefined,
    lastSendingId: lastSending && lastSending.Id ? lastSending.Id : undefined,
    sendingOrScheduleId:
      lastSending && lastSending.Id ? lastSending.Id : undefined
  }
}

export async function getSendingSegmentation(idSending) {
  const hasEngagement = evalCondition('co:DELSTATS OR co:ENGAGEMENT')
  const hasSimulation = evalCondition('co:DELTACALCSEGM')

  const {
    IdMessage,
    IdSendStop,
    Groups,
    ExcludeGroups,
    Filtri,
    Queued: queued
  } = await beSendGoGetEmailSendingDetails(idSending)

  const groupsIds = Groups.split(',')
    .filter(o => !!o)
    .map(o => parseInt(o))

  const groupsCalls = groupsIds
    .filter(id => id !== 0) // escludo il nogroups, lo controllo dopo
    .map(idGroup => {
      return idGroup !== -1
        ? beRecipientGetGroupDetails(idGroup)
        : {
            Id: idGroup
          }
    })

  const groups = (await Promise.all(groupsCalls)).map((group, index) => {
    return group
      ? {
          id: group.Id,
          name: group.Name
        }
      : {
          id: groupsIds[index],
          deleted: true
        }
  })
  // controllo il noGroups
  groupsIds.includes(0) &&
    groups.push({
      id: 0,
      name: getIntl().formatMessage({ id: 'Load.Filters.NoGroupOption' })
    })

  const excludedGroupsIds = ExcludeGroups.split(',')
    .filter(o => !!o)
    .map(o => parseInt(o))

  const excludedGroupsCalls = excludedGroupsIds.map(idGroup =>
    beRecipientGetGroupDetails(idGroup)
  )

  const excludedGroups = (await Promise.all(excludedGroupsCalls)).map(
    (group, index) => {
      return group
        ? {
            id: group.Id,
            name: group.Name
          }
        : {
            id: excludedGroupsIds[index],
            deleted: true
          }
    }
  )

  const filtersIds = Filtri.split(',')
    .filter(o => !!o)
    .map(o => parseInt(o))

  const filtersCalls = filtersIds.map(idFilter => beFiltersGetFilter(idFilter))

  const filters = (await Promise.all(filtersCalls))
    .map((filter, index) => {
      return filter
        ? {
            id: filter.Id,
            name: filter.Name,
            type: filter.Type
          }
        : {
            id: filtersIds[index],
            deleted: true
          }
    })
    .filter(({ type }) => {
      return type !== FILTER_TYPE_ENGAGEMENT || hasEngagement
    })

  const anyDeleted = []
    .concat(groups, excludedGroups, filters)
    .some(o => !!o.deleted)

  return {
    idMessage: IdMessage,
    simulationEnabled: hasSimulation && IdSendStop === 0 && !anyDeleted,
    stopped: IdSendStop !== 0,
    queued,
    groups,
    excludedGroups,
    filters
  }
}

export async function simulateSending(
  idSending,
  groups,
  excludedGroups,
  filters
) {
  const { IdList } = await beSendGoGetEmailSendingDetails(idSending)

  const config = {
    IdList,
    IdInvio: 0,
    Action: BEQUEUE_CONFIG_ACTION_MAIL,
    Type: BEQUEUE_CONFIG_TYPE_EVERYBODY,
    FiltersConditionRule: BEQUEUE_CONFIG_FILTER_COND_OR,
    AsyncQueueFilter: filters.map(({ id: IdFilter }) => ({ IdFilter })),
    AsyncQueueGroup: [
      ...groups.map(({ id: IdGroup }) => ({
        IdGroup,
        Action: BEQUEUE_CONFIG_INCLUDE
      })),
      ...excludedGroups.map(({ id: IdGroup }) => ({
        IdGroup,
        Action: BEQUEUE_CONFIG_EXCLUDE
      }))
    ]
  }

  const result = await beQueueSimulateConfigurationProcessing(config)

  return result
}

export async function getRecipientTestsDefault() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beRecipientGetTestsDefault(idList)
  return result
}

export async function getDynamicFields() {
  const fields = beRecipientGetDynamicFieldsDefinition({
    isdynamic: true
  })
  return fields
}

export async function putBeListSenderInfo(data) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beListPutSenderInfo(idList, data)
  return result
}

export async function getGroupsDetails(recipients) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items } = await beRecipientGetListOfGroupDetails(idList, {
    orderBy: 'Id',
    orderDescending: true,
    pageNumber: 1,
    pageSize: 0,
    searchType: GROUPS_SEARCH_TYPE_ECONTAINS,
    groupType:
      recipients === RECIPIENTS_TEST_GROUP ? GROUP_TYPE_TEST : undefined,
    hasRecipients: HAS_RECIPIENTS
  })

  return Items.map(({ Id, Name, Notes }) => ({
    label: Notes ? `${Id} - ${Name} (${Notes})` : `${Id} - ${Name}`,
    value: Id
  }))
}

export async function getFilters() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
  const hidden =
    loginType !== LOGIN_TYPE_ADM && loginType !== LOGIN_TYPE_ADMLIMITED
      ? false
      : undefined

  const categories = await beFiltersGetListOfCategories({
    pageSize: 0,
    pageNumber: 1,
    orderBy: 'Name',
    orderDescending: false
  })

  const allCategories = [
    {
      Id: 0,
      Name: getIntl().formatMessage({ id: 'Load.Filters.WithoutCategory' })
    },
    ...categories.Items
  ]

  const allFilters = (
    await beFiltersGetListOfFilters(idList, {
      pageSize: 0,
      pageNumber: 1,
      orderBy: 'Name',
      orderDescending: false,
      hidden
    })
  ).Items

  const result = {
    optionGroups: allCategories
      .map(({ Id, Name }) => ({
        id: Id,
        label: Name,
        values: allFilters
          .filter(({ Category }) => Category === Id)
          .map(({ Id }) => Id)
      }))
      .filter(({ values }) => values.length > 0),
    options: allFilters.map(({ Id, Name, Type, Description }) => ({
      label: `${Id} - ${Name}`,
      value: Id,
      type: Type,
      description: Description,
      name: Name
    }))
  }

  return result
}

export const GROUP_TYPE_TEST = 'Test'

export async function updateUserColumns(value) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const res = await beListUpdateUserColumns(idList, value)
  return res
}

export async function getUserColumns() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const res = await beListGetUserColumns(idList)

  return res.Columns
}

export async function searchForRecipients(searchCriteria, recipientsDataTable) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const pageNumber = 1
  const pageSize = 10
  const orderDescending = recipientsDataTable.sortOrder === PARAM_ORDER_DESC
  const orderBy = recipientsDataTable.sortBy

  const searchParams = {
    channel: CHANNEL_TYPE_EMAIL,
    status: [SUBSCRIPTION_TYPE_SUBSCRIBED],
    pageSize,
    pageNumber,
    orderDescending,
    orderBy
  }

  const {
    includeGroups,
    excludeGroups,
    selectedFilters,
    typeAppliedFilters
  } = searchCriteria

  const searchConditions = {
    IncludeGroups: [...includeGroups],
    ExcludeGroups: [...excludeGroups],
    MatchingFilters: selectedFilters.length
      ? { Condition: typeAppliedFilters, Filters: [...selectedFilters] }
      : undefined
  }

  const apiParams = new Map()
  apiParams.set('idList', idList)
  apiParams.set('searchParams', searchParams)
  apiParams.set('searchConditions', searchConditions)

  const res = await beRecipientSearchForRecipients(...apiParams.values())

  return res
}

export async function simulatePreview(
  withParams = false,
  IdInvio,
  includeGroups,
  excludeGroups,
  selectedFilters,
  typeAppliedFilters
) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  let config = {
    IdList: idList,
    IdAbTest: 0,
    IdInvio, // prima volta === 0 dopo è diverso da 0
    Action: BEQUEUE_CONFIG_ACTION_MAIL,
    Type: BEQUEUE_CONFIG_TYPE_EVERYBODY
  }

  if (withParams) {
    config = {
      ...config,
      FiltersConditionRule:
        typeAppliedFilters === MATCH_FILTER_CONDITION_ALL
          ? BEQUEUE_CONFIG_FILTER_COND_AND
          : BEQUEUE_CONFIG_FILTER_COND_OR,
      AsyncQueueFilter: selectedFilters.map(IdFilter => ({ IdFilter })),
      AsyncQueueGroup: [
        ...includeGroups.map(IdGroup => ({
          IdGroup,
          Action: BEQUEUE_CONFIG_INCLUDE
        })),
        ...excludeGroups.map(IdGroup => ({
          IdGroup,
          Action: BEQUEUE_CONFIG_EXCLUDE
        }))
      ]
    }
  }

  const result = await beQueueSimulateConfigurationProcessing(config)

  return result
}

export async function recipientsLazySearch(
  includeGroups,
  excludeGroups,
  selectedFilters,
  typeAppliedFilters
) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  // channel=Email&status=Subscribed&pageSize=1&pageNumber=1&orderBy=Id&orderDescending=true&evaluateSelectionBlackout=false
  const params = {
    channel: CHANNEL_TYPE_EMAIL,
    status: [SUBSCRIPTION_TYPE_SUBSCRIBED],
    pageSize: 1,
    pageNumber: 1
  }

  const searchConditions = {
    IncludeGroups: [...includeGroups],
    ExcludeGroups: [...excludeGroups],
    MatchingFilters: selectedFilters.length
      ? { Condition: typeAppliedFilters, Filters: [...selectedFilters] }
      : undefined
  }

  const result = await beRecipientLazySearch(idList, params, searchConditions)

  return result
}

export async function getQueueConfiguration(idConf) {
  const result = await beQueueGetConfigurationById(idConf)

  return result
}

export async function getAccountStatus() {
  const result = await beAccountsApiGetAccountStatus()

  return result
}

export async function notifyQueueing(senderEmail) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const data = {
    IdList: idList,
    Sender: senderEmail
  }

  const result = await beAccountSettingsNotifyQueueing(data)

  return result
}

export async function saveQueueingConfiguration(
  IdInvio,
  includeGroups,
  excludeGroups,
  selectedFilters,
  typeAppliedFilters
) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const config = {
    IdList: idList,
    IdAbTest: 0,
    IdInvio, // prima volta === 0 dopo è diverso da 0
    Action: BEQUEUE_CONFIG_ACTION_MAIL,
    Type: BEQUEUE_CONFIG_TYPE_EVERYBODY,
    FiltersConditionRule:
      typeAppliedFilters === MATCH_FILTER_CONDITION_ALL
        ? BEQUEUE_CONFIG_FILTER_COND_AND
        : BEQUEUE_CONFIG_FILTER_COND_OR,
    AsyncQueueFilter: selectedFilters.map(IdFilter => ({ IdFilter })),
    AsyncQueueGroup: [
      ...includeGroups.map(IdGroup => ({
        IdGroup,
        Action: BEQUEUE_CONFIG_INCLUDE
      })),
      ...excludeGroups.map(IdGroup => ({
        IdGroup,
        Action: BEQUEUE_CONFIG_EXCLUDE
      }))
    ]
  }

  const result = await beQueueSaveQueueingConfiguration(config)

  return result
}

export async function processQueueingConfiguration(idConf) {
  const result = await beQueueExecuteConfigurationProcessing(idConf)

  return result
}

export async function createInactiveSchedule(idMessage, params) {
  const result = await beSendGoCreateInactiveSchedule(idMessage, params)

  return result
}

export async function getDynamicContents(idMessages) {
  const result = await beMessGetDynamicContentByIdMessages(idMessages)

  return result
}

export async function deleteRecipients(idConf) {
  const result = await beQueueDeleteConfigurationById(idConf)
  return result
}

export async function retryCheckQueue(idAsyncQueue) {
  const { Id } = await beQueueGetRetryConfiguration(idAsyncQueue)
  return Id
}

export async function scheduleNow(idSending) {
  const [{ TimeZoneCode }] = useStorage(STORE_KEY_LIST).values

  return beSendGoSetStandBySendingToReady(idSending, {
    StartDate: new Date().toISOString(),
    TimeZoneInternalCode: TimeZoneCode,
    Source: SENDING_SOURCE_SCHEDULED_NOW
  })
}

export async function setSendingImmediate(idSending) {
  return beSendGoSetStandBySendingToReady(idSending, {
    StartDate: null,
    TimeZoneInternalCode: '',
    Source: SENDING_SOURCE_IMMEDIATE
  })
}

export async function setSendingScheduled(
  idSending,
  DateStart,
  timeZone,
  planningType
) {
  return beSendGoSetStandBySendingToReady(idSending, {
    StartDate: DateStart.toISOString(),
    TimeZoneInternalCode: timeZone,
    Source: SENDING_SOURCE_SCHEDULED,
    PlanningType: planningType
  })
}
